module.exports = "<back align-left></back> <breadcrumb items=$ctrl.breadcrumbs on-breadcrumb-click=$ctrl.onBreadcrumbClick()></breadcrumb> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/breadcrumb/breadcrumb-navigation/breadcrumb-navigation.template.html
// module id = 555
// module chunks = 0